"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("../utils/utils");
function Moveable(opt) {
    var that = {
        // Assign default values
        options: Object.assign({
            lockX: false,
            lockY: false,
            onchange: function () { return 0; }
        }, opt),
        _tapstart: function (evt) {
            _.on(document, ['mouseup', 'touchend', 'touchcancel'], that._tapstop);
            _.on(document, ['mousemove', 'touchmove'], that._tapmove);
            // Prevent default touch event
            evt.preventDefault();
            // Trigger
            that._tapmove(evt);
        },
        _tapmove: function (evt) {
            var options = that.options, cache = that.cache;
            var element = options.element;
            var b = that.options.wrapper.getBoundingClientRect();
            var x = 0, y = 0;
            if (evt) {
                var touch = evt && evt.touches && evt.touches[0];
                x = evt ? (touch || evt).clientX : 0;
                y = evt ? (touch || evt).clientY : 0;
                // Reset to bounds
                if (x < b.left)
                    x = b.left;
                else if (x > b.left + b.width)
                    x = b.left + b.width;
                if (y < b.top)
                    y = b.top;
                else if (y > b.top + b.height)
                    y = b.top + b.height;
                // Normalize
                x -= b.left;
                y -= b.top;
            }
            else if (cache) {
                x = cache.x * b.width;
                y = cache.y * b.height;
            }
            if (!options.lockX) {
                element.style.left = "calc(" + x / b.width * 100 + "% - " + element.offsetWidth / 2 + "px)";
            }
            if (!options.lockY) {
                element.style.top = "calc(" + y / b.height * 100 + "% - " + element.offsetWidth / 2 + "px)";
            }
            that.cache = { x: x / b.width, y: y / b.height };
            options.onchange(x, y);
        },
        _tapstop: function () {
            _.off(document, ['mouseup', 'touchend', 'touchcancel'], that._tapstop);
            _.off(document, ['mousemove', 'touchmove'], that._tapmove);
        },
        trigger: function () {
            that._tapmove();
        },
        update: function (x, y) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            var wrapperRect = that.options.wrapper.getBoundingClientRect();
            that._tapmove({
                clientX: wrapperRect.left + x,
                clientY: wrapperRect.top + y
            });
        },
        destroy: function () {
            var options = that.options, _tapstart = that._tapstart;
            _.off([options.wrapper, options.element], 'mousedown', _tapstart);
            _.off([options.wrapper, options.element], 'touchstart', _tapstart, {
                passive: false
            });
        }
    };
    // Initilize
    var options = that.options, _tapstart = that._tapstart;
    _.on([options.wrapper, options.element], 'mousedown', _tapstart);
    _.on([options.wrapper, options.element], 'touchstart', _tapstart, {
        passive: false
    });
    return that;
}
exports.default = Moveable;
